export enum InstructionButtonActionTypes {
  SET_PLAY_FLAG = 'SET_PLAY_FLAG',
  SET_DISABLED = 'SET_DISABLED',
  SET_CURRENT_INSTRUCTION = 'SET_CURRENT_INSTRUCTION',
}

export type InstructionButtonDispatchMethods = {
  playInstruction: () => void;
  stopInstruction: () => void;
  setDisabled: () => void;
  setCurrentInstruction: (currentInstruction: string) => void;
};

export type InstructionButtonActions =
  | { type: InstructionButtonActionTypes.SET_PLAY_FLAG; payload: boolean }
  | { type: InstructionButtonActionTypes.SET_DISABLED; payload: boolean }
  | { type: InstructionButtonActionTypes.SET_CURRENT_INSTRUCTION; payload: string };

export type InstructionButtonState = {
  currentInstruction: string | undefined;
  playInstructionFlag: boolean;
  instructionButtonDisabled: boolean;
};

export type UseInstructionButton = [InstructionButtonState, InstructionButtonDispatchMethods];
